import { useState, useEffect } from 'react';
import JSONataLinterExpressionsColumn from './JSONataLinterExpressionsColumn';
import SampleLintInputColumn from './SampleLintInputColumn';
import { extractJsonataVariablesFromTurnContext } from '@scale/shared/utils/chatTools';
import { JsonataVariable } from '@scale/shared/chat/response';

export interface JSONataExpression {
  expression: string;
  result: string | boolean;
}

interface JSONataLinterPlaygroundProps {
  ruleName?: string;
  context: any;
  expressions: JSONataExpression[];
  operator: string;
  hide?: boolean;
}

const JSONataLinterPlayground = ({
  ruleName,
  context: initialContext,
  expressions,
  operator,
  hide,
}: JSONataLinterPlaygroundProps) => {
  const [context, setContext] = useState(initialContext);
  const variables: JsonataVariable[] = extractJsonataVariablesFromTurnContext(
    context.turnContext,
    context.params,
  );

  // Ensure context is updated when the prop changes
  useEffect(() => {
    setContext(initialContext);
  }, [initialContext]);

  if (hide) {
    return null;
  }

  return (
    <div className="flex gap-3 w-full">
      <div className="basis-2/5 min-w-[450px] flex gap-3">
        <div className="grow">
          <SampleLintInputColumn
            context={context}
            variables={variables}
            onContextChange={setContext}
          />
        </div>
      </div>

      <div className="basis-3/5 pr-8">
        <JSONataLinterExpressionsColumn
          ruleName={ruleName}
          expressions={expressions}
          context={context}
          operator={operator}
        />
      </div>
    </div>
  );
};

export default JSONataLinterPlayground;
